import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["quarterSelect", "statusMessage"]
  static values = { snapshotId: String }

  assignQuarter(event) {
    event.preventDefault()

    const quarterValue = this.quarterSelectTarget.value
    if (!quarterValue) {
      this.showError("Please select a quarter")
      return
    }

    const [year, quarter] = quarterValue.split("-")

    this.setLoading(true)
    this.clearMessage()

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    fetch(`/manage/snapshots/${this.snapshotIdValue}/assign_quarter`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        Accept: "application/json",
      },
      body: JSON.stringify({
        year: year,
        quarter: quarter,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw new Error(data.error || "Failed to assign quarter")
          })
        }
        return response.json()
      })
      .then((data) => {
        if (data.success) {
          window.location.href = data.redirect_url
        } else {
          throw new Error(data.error || "Failed to assign quarter")
        }
      })
      .catch((error) => {
        this.showError(error.message)
        this.setLoading(false)
      })
  }

  showError(message) {
    this.statusMessageTarget.textContent = message
    this.statusMessageTarget.className = "text-danger"
  }

  showSuccess(message) {
    this.statusMessageTarget.textContent = message
    this.statusMessageTarget.className = "text-success small"
  }

  clearMessage() {
    this.statusMessageTarget.textContent = ""
    this.statusMessageTarget.className = "text-muted small"
  }

  setLoading(isLoading) {
    const button = this.element.querySelector(
      'button[data-action*="assignQuarter"]',
    )
    if (button) {
      button.disabled = isLoading
      button.textContent = isLoading ? "Saving..." : "Save"
    }
    this.quarterSelectTarget.disabled = isLoading
  }
}
